<template>
    <form @submit.prevent="registerAttempt">
        <div
                class="form-group"
                :class="{error: $v.registerForm.email.$error}"
        >
            <input
                    :placeholder="$t('placeholder.email')"
                    class="form-control"
                    :disabled="loading || finishingUserData && finishingUserData.email"
                    type="email"
                    v-model.lazy="registerForm.email"
                    @blur="$v.registerForm.email.$touch"
            />
            <template v-if="$v.registerForm.email.$error">
                <p
                        class="error-message"
                        v-if="!$v.registerForm.email.required"
                >
                    {{$t('validations.required', {field: $t('fields.email')})}}
                </p>
                <p
                        class="error-message"
                        v-if="!$v.registerForm.email.email"
                >
                    {{$t('validations.email', {field: $t('fields.email')})}}
                </p>
                <p
                        class="error-message"
                        v-if="!$v.registerForm.email.notInUse"
                >
                    {{$t('validations.notInUse', {field: $t('fields.email')})}}
                </p>
            </template>
        </div>
        <div
                v-if="!this.finishingUserData"
                class="form-group"
                :class="{error: $v.registerForm.email_confirm.$error}"
        >
            <input
                    :placeholder="$t('placeholder.email_confirm')"
                    class="form-control"
                    :disabled="loading || finishingUserData && finishingUserData.email"
                    type="email"
                    v-model.lazy="registerForm.email_confirm"
                    @blur="$v.registerForm.email_confirm.$touch"
            />
            <template v-if="$v.registerForm.email_confirm.$error">
                <p
                        class="error-message"
                        v-if="!$v.registerForm.email_confirm.required"
                >
                    {{$t('validations.required', {field: $t('fields.email_confirm')})}}
                </p>
                <p
                        class="error-message"
                        v-if="!$v.registerForm.email_confirm.sameAs"
                >
                    {{$t('validations.sameAs', {field: $t('fields.email_confirm')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.registerForm.password.$error}"
        >
            <input
                    class="form-control"
                    :disabled="loading"
                    type="password"
                    v-model="registerForm.password"
                    @input="$v.registerForm.password.$touch"
                    :placeholder="$t('placeholder.password')"
            />
            <template v-if="$v.registerForm.password.$error">
                <p
                        class="error-message"
                        v-if="!$v.registerForm.password.required"
                >
                    {{$t('validations.required', {field: $t('fields.password')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.registerForm.password_confirm.$error}"
        >
            <input
                    class="form-control"
                    :disabled="loading"
                    type="password"
                    v-model="registerForm.password_confirm"
                    @input="$v.registerForm.password_confirm.$touch"
                    :placeholder="$t('placeholder.password_confirm')"
            />
            <template v-if="$v.registerForm.password_confirm.$error">
                <p
                        class="error-message"
                        v-if="!$v.registerForm.password_confirm.required"
                >
                    {{$t('validations.required', {field: $t('fields.password_confirm')})}}
                </p>
                <p
                        class="error-message"
                        v-if="!$v.registerForm.password_confirm.sameAs"
                >
                    {{$t('validations.sameAs', {field: $t('fields.password_confirm')})}}
                </p>
            </template>
        </div>
        <div class="captcha-container" :sitekey="recaptchaPublicKey" v-if="recaptchaPublicKey">
            <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="recaptchaPublicKey"
                    :loadRecaptchaScript="true"
                    :theme="'dark'"
                    @verify="registerForm.recaptcha = $event"
                    @expire="registerForm.recaptcha = null"
            />
            <template v-if="$v.registerForm.recaptcha.$error">
                <p
                        class="error-message"
                        v-if="!$v.registerForm.recaptcha.required"
                >
                    {{$t('validations.captcha')}}
                </p>
            </template>
        </div>

        <div class="messages">
            <div
                    v-for="(errors, errorKey) in registerErrors"
                    :key="errorKey"
            >
                <p
                        v-for="error in errors"
                        :key="error"
                >
                    {{error}}
                </p>
            </div>
        </div>

        <div class="buttons">
            <button
                    class="btn-register"
                    v-if="!loading"
                    type="submit"
            >
                {{$t('register.buttons.register')}}
            </button>
            <Spinner v-else/>
        </div>
    </form>
</template>

<script>
  import Spinner from "./Spinner";
  import { required, email, sameAs, requiredIf } from 'vuelidate/lib/validators'
  import resources from '../resources';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
      components: {
          Spinner,
          VueRecaptcha,
      },
      props: {
          finishingUserData: {
              required: false,
              default(){
                  return null;
              }
          }
      },
      data(){
          return {
              registerForm: {
                  email: '',
                  email_confirm: '',
                  password: '',
                  password_confirm: '',
                  recaptcha: null,
                  finish_token: null,
              },
              loading: false,
              registerErrors: {},
          }
      },
      created(){

      },
      methods: {
          registerAttempt(){
              if(this.$v.registerForm.$invalid){
                  return this.$v.registerForm.$touch();
              }

              this.loading = true;

              this.$auth.register({
                  body: this.registerForm,
                  success: function (resp) {
                      this.loading = false;
                      this.$emit('successfullRegister', resp);
                  },
                  error: function (resp) {
                      if(this.recaptchaPublicKey){
                          this.$refs.recaptcha.reset();
                          this.registerForm.recaptcha = null;
                          //TODO: Unset dirty flag
                      }

                      this.loading = false;
                      this.registerErrors = resp.data.errors || {general: [this.$t('error')]};
                      this.$emit('failedRegister', resp);
                  },
                  redirect: null,
                  autoLogin: true,
              });
          }
      },
      computed: {
          recaptchaPublicKey(){
              return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
          }
      },
      validations(){
          return {
              registerForm: {
                  email: {
                      required,
                      email,
                      notInUse(value) {
                          if (value === '' || this.finishingUserData) {
                              return true;
                          }

                          return new Promise((resolve, reject) => {
                              resources.unavailableEmails.index({email: value})
                                  .then(resp => {
                                      resolve(resp.data.data.length === 0);
                                  });
                          })
                      },
                  },
                email_confirm: {
                  required: requiredIf(() => !this.finishingUserData),
                  // email,
                  sameAs(value) {
                    return this.finishingUserData || value === this.registerForm.email;
                  },
                },
                  password: {
                      required,
                  },
                  password_confirm: {
                      required,
                      sameAsPassword: sameAs('password'),
                  },
                  recaptcha: {
                      required: requiredIf(() => this.recaptchaPublicKey)
                  }
              }
          };
      },
      watch: {
          loading(){
              this.$emit('loadingChange', this.loading);
          },
          finishingUserData: {
              handler(finishingUserData){
                  if(finishingUserData){
                      Object.keys(finishingUserData).forEach((key) => {
                          if(finishingUserData.hasOwnProperty(key)){
                              this.$set(this.registerForm, key, finishingUserData[key]);
                          }
                      });
                  }
              },
              immediate: true,
          }
      }
  }
</script>

<style scoped lang="scss">
    @import '../styles/classes';
    @import '../styles/variables';

    .buttons{
        margin-bottom: 30px;
    }

    .btn-register{
        @extend %fresh-btn;
        display: block;
        width: 100%;
        padding: 1em;
    }
</style>